import { isObject } from 'paliari-js-utils'

/**
 * @param {array, object} errors
 * @param {array} ret
 * @returns {array}
 */
const parseErrors = (errors, ret = []) => {
  for (const i in errors) {
    const e = errors[i]

    if (isObject(e)) {
      if (e.message) {
        ret.push(e.message)
      } else if (e.id && e.mensagem) {
        ret.push(`${e.id}: ${e.mensagem}`)
      } else {
        ret.concat(parseErrors(e, ret))
      }
    } else {
      ret.push(e)
    }
  }

  return ret
}

export default parseErrors
